import { createSlice } from "@reduxjs/toolkit";
const initialState = {
    entryLocation: null,
    path: "",
    isOverlayLogin: false,
    isSideNavigationMenu: false,
    isCreateDropdownOpen: false,
    showOnboardingModal: false,
    onboardingFinished: false,
};
const navigationSlice = createSlice({
    name: "navigation",
    initialState,
    reducers: {
        navigateRoute: (state, action) => {
            state.path = action.payload;
        },
        setIsOverlayLogin: (state, action) => {
            state.isOverlayLogin = action.payload;
        },
        setSideNavigationMenu: (state, action) => {
            state.isSideNavigationMenu = action.payload;
        },
        setCreateDropdownMenu: (state, action) => {
            state.isCreateDropdownOpen = action.payload;
        },
        setEntryLocation: (state, action) => {
            state.entryLocation = action.payload;
        },
        setShowOnboardingModal: (state, action) => {
            state.showOnboardingModal = action.payload;
        },
        setOnboardingFinished: (state, action) => {
            state.onboardingFinished = action.payload;
        },
        toggleOverlayLogin: (state) => {
            state.isOverlayLogin = !state.isOverlayLogin;
        },
    },
});
export const { navigateRoute, setIsOverlayLogin, setSideNavigationMenu, setCreateDropdownMenu, setEntryLocation, setShowOnboardingModal, setOnboardingFinished, toggleOverlayLogin, } = navigationSlice.actions;
export default navigationSlice.reducer;
